export const blocks = [
  {
    number: '01',
    weeks: 'Weeks 1–4',
    start: 1,
    end: 4,
    title: 'Foundations & Starting Benchmarks',
    description:
      'Begin with organized sessions focused on movement practice, manageable workloads, and starting-point assessments.',
    tags: ['Movement Practice', 'Manageable Workloads', 'Starting Benchmarks'],
  },
  {
    number: '02',
    weeks: 'Weeks 5–8',
    start: 5,
    end: 8,
    title: 'Strength & Aerobic Development',
    description:
      'Follow planned strength and conditioning sessions with clear work periods, recovery, and progression.',
    tags: ['Strength', 'Conditioning', 'Work & Recovery', 'Progression'],
  },
  {
    number: '03',
    weeks: 'Weeks 9–13',
    start: 9,
    end: 13,
    title: 'Work Capacity & Controlled Combinations',
    description:
      'Bring running and station work together through structured sessions with defined effort and timing.',
    tags: ['Running', 'Station Work', 'Defined Effort', 'Timing'],
  },
  {
    number: '04',
    weeks: 'Weeks 14–17',
    start: 14,
    end: 17,
    title: 'Running-to-Station Transitions',
    description: 'Use sessions that organize the shift between running and functional work.',
    tags: ['Run-to-Station', 'Functional Work', 'Transitions'],
  },
  {
    number: '05',
    weeks: 'Weeks 18–21',
    start: 18,
    end: 21,
    title: 'Specific Hybrid Preparation',
    description: 'Deliver integrated hybrid sessions with planned workload and appropriate adaptations.',
    tags: ['Hybrid Sessions', 'Planned Workload', 'Adaptations'],
  },
  {
    number: '06',
    weeks: 'Weeks 22–26',
    start: 22,
    end: 26,
    title: 'Consolidation & Reassessment',
    description: 'Bring the program together, revisit scheduled benchmarks, and record progress.',
    tags: ['Consolidation', 'Benchmarks', 'Progress Records'],
  },
];
